<template>
  <div class="basic-info">
    <v-dialog v-model="nameChange" width="400px">
      <div class="nameChangeModal">
        <font style="font-size: 1.6rem; font-weight: bold"
          >Change your name</font
        >
        <v-text-field label="Your name" v-model="namefield"> </v-text-field>
        <div class="row" style="margin-top: 2rem !important">
          <div class="btn btn-save" @click="changeName">Save</div>
          <div
            class="btn btn-outline"
            style="margin-left: 2rem"
            @click="nameChange = false"
          >
            Cancel
          </div>
        </div>
      </div>
    </v-dialog>
    <div class="basic-info-content" id="profile">
      <div class="top-section">
        <div class="responsive-pp">
          <div
            class="profileImage absolute-center-row"
            @click="changeProfilePicture"
          >
            <div class="ChangeImageOverlay absolute-center-row">
              <div class="camera absolute-center-row">
                <CustomIcon name="camera" genericColor />
              </div>
            </div>
            <img style="width: 100%; hegth: auto" :src="userImage" />
          </div>
          <div align="left" style="margin-left: 1.9rem" class="phone-block">
            <div style="color: #707070">
              A clear and professional photo is always a good start!
            </div>
            <div class="btn btn-save" style="margin-top: 2.5rem">
              Change photo
            </div>
          </div>
        </div>
        <div
          class="row align-items-center phone-between"
          style="margin-top: 1.6rem !important"
        >
          <div class="row info-text name hvr-name">{{ username }}</div>
          <div v-if="!edit_status" class="name-edit" @click="nameChange = true">
            <CustomIcon name="edit" genericColor />
          </div>
        </div>

        <v-progress-linear
          v-model="profileCompletionStatus.percentages"
          background-color="#001844"
          color="#008e50"
          height="5"
          class="pc-mode"
        ></v-progress-linear>
        <div class="profile-completion" style="position: relative">
          Profile completion: {{ profileCompletionStatus.percentages }}%
          <div style="position: absolute; top: 0.5rem; left: -4rem">
            <tips-wrapper ref="tips">
              <div style="width:40rem;white-space: normal;">
                An incomplete profile appears at the very bottom of the candidate list.
                We suggest adding your <font style="color:blue">Education, Experience, Skills</font> and <font style="color:blue">Upload a resume</font> to your profile.
              </div>
            </tips-wrapper>
          </div>
        </div>
      </div>
      <!-- <div class="info-item">
        <div class="row lbl-text">Name</div>
        <div class="row info-text name">{{ user.name }}</div>
      </div> -->
      <div class="info-item hvr-status">
        <div class="row lbl-text">Profile Status</div>
        <div v-if="!edit_status" class="info-text status">
          {{ profile_status[status_number] }}
        </div>
        <div
          v-if="!edit_status"
          @click="edit_profile_status"
          style="top: 1.5rem; right: 1rem"
          class="icon-class icon-class-edit hvr-status-edit"
        >
          <CustomIcon name="edit" genericColor />
        </div>

        <div
          v-if="edit_status"
          style="width: calc(100% - 7rem); margin-top: 1rem"
        >
          <v-select
            :items="profile_status"
            v-model="selected"
            label="Solo field"
            solo
            outline
          ></v-select>
        </div>
        <div style="" class="row" v-if="edit_status">
          <div class="save" @click="saveStatus">Save</div>
          <div class="cancel" @click="edit_status = false">Cancel</div>
        </div>
      </div>
      <div v-if="!editPhone" class="info-item editableItems hvr-phone">
        <div class="row lbl-text">Phone</div>
        <div class="row info-text">
          <div class="editableItemsDiv">
            {{ displayPhone || "N/A" }}
            <div
              class="icon-class icon-class-edit hvr-phone-edit"
              @click="onClickEditPhone"
            >
              <CustomIcon name="edit" genericColor />
            </div>
          </div>
        </div>
      </div>
      <div v-else class="info-item editableItems">
        <div style="max-width: 60rem">
          <v-text-field
            type="text"
            v-model="phone"
            label="Phone"
            :error-messages="phoneErrors"
          ></v-text-field>
          <div class="row">
            <div class="save" @click="savePhone">Save</div>
            <div class="cancel" @click="editPhone = false">Cancel</div>
          </div>
        </div>
      </div>
      <div class="info-item">
        <div class="row lbl-text">Email</div>
        <div class="row info-text email">{{ user.email }}</div>
      </div>

      <div v-if="!editLocation" class="info-item editableItems hvr-location">
        <div class="row lbl-text">Location</div>
        <div class="row info-text">
          <div class="editableItemsDiv">
            {{ displayLocation || "N/A" }}
            <div
              @click="onClickEditLocation"
              style="margin-left: 5rem"
              class="icon-class icon-class-edit hvr-location-edit"
            >
              <CustomIcon name="edit" genericColor />
            </div>
          </div>
        </div>
      </div>
      <div v-else class="info-item editableItems">
        <div style="max-width: 60rem">
          <v-text-field
            type="text"
            v-model="location"
            label="Location"
            :error-messages="locationLengthErrors"
          ></v-text-field>
          <div class="row">
            <div class="save" @click="saveLocation">Save</div>
            <div class="cancel" @click="editLocation = false">Cancel</div>
          </div>
        </div>
      </div>
      <div v-if="!editLinkedin" class="info-item editableItems hvr-linkedin">
        <div class="row lbl-text">Linkedin Profile</div>
        <div class="row info-text">
          <div class="editableItemsDiv">
            <a
              v-if="displayLinkedin"
              class="tips-hover"
              style="text-decoration: underline; color: var(--link-color);position:relative"
              @click="openProjectUrl"
              >{{ displayLinkedin.length>40?displayLinkedin.substr(0,40)+"...":displayLinkedin }}
              <div v-if="displayLinkedin.length>40" class="custom-tips" style="left:-5%;top:2.5rem;z-index:100">{{displayLinkedin}}</div>
              </a>
            <span v-else>N/A</span>
            <div
              @click="onClickEditLinkedIn"
              style="margin-left: 5rem"
              class="icon-class icon-class-edit hvr-linkedin-edit"
            >
              <CustomIcon name="edit" genericColor />
            </div>
          </div>
        </div>
      </div>
      <div v-else class="info-item editableItems">
        <div style="max-width: 60rem">
          <v-text-field
            type="text"
            v-model="linkedin"
            label="Linkedin Profile"
            :error-messages="LinkedInErrors"
            hint="https://www.linkedin.com/in/your-username"
            persistent-hint
          ></v-text-field>
          <div class="row">
            <div class="save" @click="saveLinkedin">Save</div>
            <div class="cancel" @click="editLinkedin = false">Cancel</div>
          </div>
        </div>
      </div>
      <div class="info-item editableItems hvr-gender">
        <div class="row lbl-text">Gender</div>
        <div v-if="!editGender" class="row info-text">
          <div class="editableItemsDiv">
            {{
              displayGender.charAt(0).toUpperCase() +
                displayGender.slice(1).toLowerCase() || "N/A"
            }}
            <div
              @click="onClickEditGender"
              style="margin-left: 5rem"
              class="icon-class icon-class-edit hvr-gender-edit"
            >
              <CustomIcon name="edit" genericColor />
            </div>
          </div>
        </div>
        <div class="editableItemsDiv" v-else>
          <div class="row">
            <div
              style="margin-right: 2rem; cursor: pointer"
              @click="gender = 'male'"
            >
              <v-icon
                size="14"
                class="radio-icon"
                v-bind:class="{ active: checkGender('male') }"
                >mdi-gender-male</v-icon
              >
              <span style="font-size: 1.8rem">Male</span>
            </div>
            <div
              style="margin-right: 2rem; cursor: pointer"
              @click="gender = 'female'"
            >
              <v-icon
                size="14"
                class="radio-icon"
                v-bind:class="{ active: checkGender('female') }"
                >mdi-gender-female</v-icon
              >
              <span style="font-size: 1.8rem">Female</span>
            </div>
          </div>
          <div class="row" style="margin-top: 1rem !important">
            <div class="save" @click="saveGender">Save</div>
            <div class="cancel" @click="editGender = false">Cancel</div>
          </div>
        </div>
      </div>
    </div>
    <v-snackbar :color="bgColor" :timeout="timeOut" top v-model="snackbar">
      <div style="text-align: center; width: 100%">
        <span style="padding-right: 1rem">
          <v-icon color="#fff">{{ snackIcon }}</v-icon>
        </span>
        {{ snackMessage }}
      </div>
    </v-snackbar>
    <div :key="changePic" v-if="changePicture">
      <change-image
        v-bind:image="userImage"
        v-on:update-picture="updateProfilePicture"
      ></change-image>
    </div>
  </div>
</template>

<script>
import * as SYSTEM_CONSTANT from "../../../../globalConstants";
import * as FILTERS from "../../../../filters";
import { validationMixin } from "vuelidate";
import { maxLength, helpers } from "vuelidate/lib/validators";
import {
  GET_USER_DEMOGRAPHIC_INFO,
  SAVE_USER_DEMOGRAPHIC_INFO,
} from "../../../../Api/candidate_api";
import ChangeImage from "../../../global-components/change-image";
import TipsWrapper from "../../../global-components/tipswrapper"
import { IMAGE } from "../../../../Api/common_api";
import CustomIcon from "../../../global-components/customIcon";
import { GET_PROFILE_COMPLETION_STATUS } from "../../../../Api/candidate_api";
import ChangePassword from "../../settings/change-password.vue";
const phone_validator = helpers.regex(
  "phone_validator",
  /^(?:\+?(?:88|01)?)(?:\d{11}|\d{13})$/
);
import Store from "../../../../store/store";
import { PHONE } from "../../../../globalFunctions";
export default {
  name: "basic-info",
  mixins: [validationMixin],
  validations: {
    location: {
      maxLength: maxLength(300),
    },
    phone: {
      phone_validator,
    },
    linkedin: {
      isValid() {
        return (
          this.linkedin.includes("https://www.linkedin.com/in/") ||
          this.linkedin === ""
        );
      },
      maxLength: maxLength(100),
    },
  },
  components: {
    ChangeImage,
    CustomIcon,
    TipsWrapper
  },
  data: function () {
    return {
      profile_status: [
        "Actively searching",
        "Casually searching",
        "Not searching, but open to inquiry",
        "Not searching",
      ],
      phoneMode: PHONE(),
      editLocation: false,
      editGender: false,
      editPhone: false,
      editLinkedin: false,
      phone: "",
      displayPhone: "",
      location: "",
      displayLocation: "",
      gender: "",
      displayGender: "",
      displayLinkedin: "",
      linkedin: "",
      user: SYSTEM_CONSTANT.getOwnerInfo(),
      bgColor: "#454545",
      timeOut: 2000,
      snackbar: false,
      snackIcon: "",
      snackMessage: "",
      ripple: false,
      status_number: 1,
      edit_status: false,
      selected: "",
      changePicture: false,
      changePic: 0,
      userImage: this.phoneMode
        ? require("@/assets/newDesign/profile-avatar-dark.svg")
        : require("@/assets/newDesign/profile-avatar-w.svg"),
      profileCompletionStatus: {},
      nameChange: false,
      namefield: Store.getters.getName,
    };
  },
  methods: {
    tipsopen() {
      this.$refs.tips.open();
    },
    tipsclose(){
      this.$refs.tips.open();
    },
    openProjectUrl() {
      const self = this;
      if (
        self.displayLinkedin.includes("https://") ||
        self.displayLinkedin.includes("http://")
      ) {
        window.open(self.displayLinkedin, "_blank");
      } else {
        window.open("https://" + self.displayLinkedin, "_blank");
      }
    },
    edit_profile_status: function () {
      this.edit_status = true;
      this.selected = this.profile_status[this.status_number];
    },
    checkGender(key) {
      const self = this;
      return key === self.gender;
    },
    changeName() {
      const self = this;
      let data = {
        user_name: self.namefield,
      };
      SAVE_USER_DEMOGRAPHIC_INFO(data)
        .then(function (response) {
          self.snackbar = true;
          self.snackIcon = SYSTEM_CONSTANT.SNACKBAR_ICON.SUCCESS;
          self.bgColor = SYSTEM_CONSTANT.SNACKBAR_COLOR.SUCCESS;
          self.snackMessage = response.message;
          self.$store.commit("changeUserName", self.namefield);
          // let temp=self.$constants.getOwnerInfo()
          let temp = Object.assign(self.$constants.getOwnerInfo(), {
            name: self.namefield,
          });
          localStorage.setItem("user", JSON.stringify(temp));
          self.nameChange = false;
          self.getUserDemographicInfo();
        })
        .catch(function (error) {
          self.snackbar = true;
          self.snackIcon = SYSTEM_CONSTANT.SNACKBAR_ICON.ERROR;
          self.bgColor = SYSTEM_CONSTANT.SNACKBAR_COLOR.ERROR;
          self.snackMessage = error.message;
        });
    },
    onClickEditGender() {
      const self = this;
      self.gender = self.displayGender;
      self.editGender = true;
    },
    onClickEditPhone: function () {
      const self = this;
      self.phone = self.displayPhone;
      self.editPhone = true;
    },
    onClickEditLocation: function () {
      const self = this;
      self.location = self.displayLocation;
      self.editLocation = true;
    },
    onClickEditLinkedIn: function () {
      const self = this;
      self.linkedin = self.displayLinkedin;
      self.editLinkedin = true;
    },
    onClickCancel: function () {
      const self = this;
      self.edit = false;
    },
    getUserDemographicInfo: function () {
      const self = this;
      GET_USER_DEMOGRAPHIC_INFO()
        .then(function onSuccess(data) {
          if (data.location_name) {
            self.location = data.location_name;
            self.displayLocation = data.location_name;
          } else {
            self.location = "";
            self.displayLocation = "";
          }
          if (data.gender) {
            self.gender = data.gender;
            self.displayGender = data.gender;
          } else {
            self.gender = "";
            self.displayGender = "";
          }
          if (data.phone) {
            self.phone = data.phone;
            self.displayPhone = data.phone;
          } else {
            self.phone = "";
            self.displayPhone = "";
          }
          if (data.profile_status) {
            self.status_number = data.profile_status - 1;
            self.edit_status = false;
          }
          if (data.linkedin) {
            self.linkedin = data.linkedin;
            self.displayLinkedin = data.linkedin;
          } else {
            self.linkedin = "";
            self.displayLinkedin = "";
          }
        })
        .catch(function onError(error) {
          self.snackbar = true;
          self.snackIcon = SYSTEM_CONSTANT.SNACKBAR_ICON.ERROR;
          self.bgColor = SYSTEM_CONSTANT.SNACKBAR_COLOR.ERROR;
          self.snackMessage = error.message;
        });
    },
    saveGender() {
      const self = this;
      self.$v.$touch();
      let data = {
        gender: self.gender,
      };
      SAVE_USER_DEMOGRAPHIC_INFO(data)
        .then(function (response) {
          self.snackbar = true;
          self.snackIcon = SYSTEM_CONSTANT.SNACKBAR_ICON.SUCCESS;
          self.bgColor = SYSTEM_CONSTANT.SNACKBAR_COLOR.SUCCESS;
          self.snackMessage = response.message;
          self.editGender = false;
          self.getUserDemographicInfo();
        })
        .catch(function (error) {
          self.snackbar = true;
          self.snackIcon = SYSTEM_CONSTANT.SNACKBAR_ICON.ERROR;
          self.bgColor = SYSTEM_CONSTANT.SNACKBAR_COLOR.ERROR;
          self.snackMessage = error.message;
        });
    },
    savePhone: function () {
      const self = this;
      self.$v.$touch();
      if (!self.$v.phone.$anyError) {
        let data = {
          phone: FILTERS.REMOVE_WHITE_SPACES(self.phone),
        };
        SAVE_USER_DEMOGRAPHIC_INFO(data)
          .then(function (response) {
            self.snackbar = true;
            self.snackIcon = SYSTEM_CONSTANT.SNACKBAR_ICON.SUCCESS;
            self.bgColor = SYSTEM_CONSTANT.SNACKBAR_COLOR.SUCCESS;
            self.snackMessage = response.message;
            self.editPhone = false;
            let user = JSON.parse(localStorage.getItem("user"));
            user.phone = self.phone;
            localStorage.setItem("user", JSON.stringify(user));
            self.getUserDemographicInfo();
            self.getUserDemographicInfo();
          })
          .catch(function (error) {
            self.snackbar = true;
            self.snackIcon = SYSTEM_CONSTANT.SNACKBAR_ICON.ERROR;
            self.bgColor = SYSTEM_CONSTANT.SNACKBAR_COLOR.ERROR;
            self.snackMessage = error.message;
          });
      }
    },
    saveLocation: function () {
      const self = this;
      self.$v.$touch();
      if (!self.$v.location.$anyError) {
        let data = {
          location: FILTERS.REMOVE_WHITE_SPACES(self.location),
        };
        SAVE_USER_DEMOGRAPHIC_INFO(data)
          .then(function (response) {
            self.snackbar = true;
            self.snackIcon = SYSTEM_CONSTANT.SNACKBAR_ICON.SUCCESS;
            self.bgColor = SYSTEM_CONSTANT.SNACKBAR_COLOR.SUCCESS;
            self.snackMessage = response.message;
            self.editLocation = false;
            self.getUserDemographicInfo();
          })
          .catch(function (error) {
            self.snackbar = true;
            self.snackIcon = SYSTEM_CONSTANT.SNACKBAR_ICON.ERROR;
            self.bgColor = SYSTEM_CONSTANT.SNACKBAR_COLOR.ERROR;
            self.snackMessage = error.message;
          });
      }
    },
    saveLinkedin: function () {
      const self = this;
      self.$v.$touch();
      if (!self.$v.linkedin.$anyError) {
        let data = {
          linkedin: FILTERS.REMOVE_WHITE_SPACES(self.linkedin),
        };
        SAVE_USER_DEMOGRAPHIC_INFO(data)
          .then(function (response) {
            self.snackbar = true;
            self.snackIcon = self.$constants.SNACKBAR_ICON.SUCCESS;
            self.bgColor = SYSTEM_CONSTANT.SNACKBAR_COLOR.SUCCESS;
            self.snackMessage = response.message;
            self.editLinkedin = false;
            self.getUserDemographicInfo();
          })
          .catch(function (error) {
            self.snackbar = true;
            self.snackIcon = SYSTEM_CONSTANT.SNACKBAR_ICON.ERROR;
            self.bgColor = SYSTEM_CONSTANT.SNACKBAR_COLOR.ERROR;
            self.snackMessage = error.message;
          });
      }
    },
    saveStatus: function () {
      const self = this;
      self.$v.$touch();
      let data = {
        profile_status: self.profile_status.indexOf(self.selected) + 1,
      };
      SAVE_USER_DEMOGRAPHIC_INFO(data)
        .then(function (response) {
          self.snackbar = true;
          self.snackIcon = SYSTEM_CONSTANT.SNACKBAR_ICON.SUCCESS;
          self.bgColor = SYSTEM_CONSTANT.SNACKBAR_COLOR.SUCCESS;
          self.snackMessage = response.message;
          self.editLocation = false;
          self.$store.commit(
            "changeStatus",
            self.profile_status.indexOf(self.selected) + 1
          );
          let user = JSON.parse(localStorage.getItem("user"));
          user.profile_status = self.profile_status.indexOf(self.selected) + 1;
          localStorage.setItem("user", JSON.stringify(user));
          self.getUserDemographicInfo();
        })
        .catch(function (error) {
          self.snackbar = true;
          self.snackIcon = SYSTEM_CONSTANT.SNACKBAR_ICON.ERROR;
          self.bgColor = SYSTEM_CONSTANT.SNACKBAR_COLOR.ERROR;
          self.snackMessage = error.message;
        });
    },
    getProfileCompletionStatus() {
      const self = this;
      GET_PROFILE_COMPLETION_STATUS()
        .then(function (data) {
          self.profileCompletionStatus = data;
          let percentages = 0;
          if (self.profileCompletionStatus.education) {
            percentages += 30;
          }
          if (self.profileCompletionStatus.experience) {
            percentages += 10;
          }
          if (self.profileCompletionStatus.skill) {
            percentages += 30;
          }
          if (self.profileCompletionStatus.image) {
            percentages += 10;
          }
          if (self.profileCompletionStatus.resume) {
            percentages += 10;
          }
          if (self.profileCompletionStatus.phone) {
            percentages += 10;
          }
          self.profileCompletionStatus.percentages = percentages;
          if (self.profileCompletionStatus.percentages < 30) {
            self.profileCompletionStatus.color =
              self.$constants.SNACKBAR_COLOR.ERROR_ALT;
          } else if (self.profileCompletionStatus.percentages < 60) {
            self.profileCompletionStatus.color =
              self.$constants.SNACKBAR_COLOR.WARNING_ALT;
          }
          const comp = JSON.stringify(self.profileCompletionStatus);
          localStorage.setItem("completeness", comp);
          self.profileCompletionStatus.percentages<60&&self.tipsopen();
        })
        .catch(function () {
          self.profileCompletionStatus = {};
        });
    },
    changeProfilePicture: function () {
      const self = this;
      self.updateProfilePicture("open");
    },
    updateProfilePicture(open) {
      const self = this;
      clearTimeout(self.timeout);
      let params = {
        url_only: 1,
      };
      IMAGE(params).then(function (data) {
        self.userImage = data.image_url
          ? data.image_url
          : self.phoneMode
          ? require("@/assets/newDesign/profile-avatar-dark.svg")
          : require("@/assets/newDesign/profile-avatar-w.svg");
        self.timeout = setTimeout(function () {
          if (open === "open") {
            self.changePic++;
            self.changePicture = true;
          }
        }, self.$constants.DELAY.IMAGE_FETCH_DELAY);
      });
    },
  },
  computed: {
    locationLengthErrors() {
      const errors = [];
      if (!this.$v.location.$dirty) return errors;
      !this.$v.location.maxLength &&
        errors.push(SYSTEM_CONSTANT.REQUIRED_MESSAGE.LENGTH_TOO_LONG);
      return errors;
    },
    phoneErrors() {
      const errors = [];
      if (!this.$v.phone.$dirty) return errors;
      !this.$v.phone.phone_validator &&
        errors.push(SYSTEM_CONSTANT.REQUIRED_MESSAGE.PHONE_INVALID);
      return errors;
    },
    LinkedInErrors() {
      const errors = [];
      if (!this.$v.linkedin.$dirty) return errors;
      !this.$v.linkedin.isValid && errors.push("Invalid URL");
      !this.$v.linkedin.maxLength &&
        errors.push(SYSTEM_CONSTANT.REQUIRED_MESSAGE.LENGTH_TOO_LONG);
      return errors;
    },
    username() {
      return Store.getters.getName;
    },
  },
  mounted: function () {
    const self = this;
    self.getUserDemographicInfo();
    self.updateProfilePicture();
    self.getProfileCompletionStatus();
    
  },
};
</script>

<style scoped>
.save {
  color: var(--button-color);
  cursor: pointer;
}
.cancel {
  margin-left: 2rem;
  color: var(--button-delete-color);
  cursor: pointer;
}
.top-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 25rem;
  border-top-left-radius: 0.8rem;
  border-top-right-radius: 0.8rem;
  padding: 1rem 1rem 1.5rem 1rem;
  background-image: linear-gradient(to left, #29abe2 -8%, #1c56ac);
}
.profileImage {
  height: 12.5rem;
  width: 12.5rem;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  margin-top: 1.5rem;
}
.name-edit {
  margin-left: 1rem;
  color: white;
  cursor: pointer;
}
.ChangeImageOverlay {
  height: 100%;
  width: 100%;
  border-radius: 50%;
  background-color: black;
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  content: " ";
  transition: 0.5s;
  background-color: rgba(0, 0, 0, 0.3);
}
.camera {
  height: 4.2rem;
  width: 4.2rem;
  border-radius: 50%;
  background-color: black;
  color: white;
}
.profileImage:hover .ChangeImageOverlay {
  display: flex;
  transition: 0.5s;
}

.icon-class {
  color: black;
  border-radius: 50%;
  font-size: 1.5rem;
  height: 2.7rem;
  width: 2.7rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: white;
  /* transition: 0.4s; */
  cursor: pointer;
}
.icon-class-edit {
  position: absolute;
  top: 0;
  right: 0;
}
.icon-class:hover {
  /* transition: 0.4s; */
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.16);
}
.nameChangeModal {
  width: 100%;
  background-color: white;
  padding: 4rem;
  text-align: left;
  font-size: bold;
  font-weight: 1.6rem;
}
.icon-close {
  background-color: white;
  color: black;
  border-radius: 0.2rem;
  font-size: 1.5rem;
  height: 2.7rem;
  width: 2.7rem;
  border-radius: 50%;
}
.icon-close:hover {
  color: #ffffff;
  background-color: var(--button-delete-color);
}
.icon-check {
  background-color: white;
  color: black;
  padding: 0.3rem;
  border-radius: 0.2rem;
  font-size: 1.5rem;
  height: 2.7rem;
  width: 2.7rem;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.icon-check:hover {
  background-color: var(--button-color);
  color: #ffffff;
}
.radio-icon {
  background-color: #bbbbbb;
  color: #ffffff;
  border-radius: 50%;
  padding: 0.3rem;
  margin-right: 0.5rem;
}
.active {
  background-color: var(--button-color);
  color: #ffffff !important;
}
.basic-info {
  border-radius: 0.8rem;
  width: 100%;
  background-color: #ffffff;
  position: relative;
  border: 1px solid #d9d9d9;
  border-radius: 7px;
}
/* .basic-info-content {
  padding: 1rem;
 
} */
.info-item {
  padding: 1rem;
  text-align: left;
  border-top: 1px solid #d9d9d9;
  position: relative;
}
.editableItems {
}
.editableItemsDiv {
  width: 100%;
  position: relative;
  padding-right: 2rem;
}
.hvr-name {
  cursor: pointer;
}
/* .hvr-name-edit {
  visibility: hidden;
  transition: 0.5s;
} */
.hvr-status-edit {
  visibility: hidden;
}
.hvr-phone-edit {
  visibility: hidden;
}
.hvr-location-edit {
  visibility: hidden;
}
.hvr-linkedin-edit {
  visibility: hidden;
}

.hvr-gender-edit {
  visibility: hidden;
}
.hvr-name:hover .name-edit {
  display: block;
}
.hvr-status:hover .hvr-status-edit {
  visibility: visible;
}
.hvr-phone:hover .hvr-phone-edit {
  visibility: visible;
}
.hvr-location:hover .hvr-location-edit {
  visibility: visible;
}
.hvr-linkedin:hover .hvr-linkedin-edit {
  visibility: visible;
}
.hvr-gender:hover .hvr-gender-edit {
  visibility: visible;
}
.profile-completion {
  color: white;
  font-size: 1.2rem;
}
.phone-block {
  display: none;
}

@media (max-width: 800px) {
  .top-section {
    background-color: white;
    background-image: none;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0;
    height: auto;
  }
  .profileImage {
    width: 9.87rem;
    height: auto;
    border-radius: 0;
    margin-left: 1.5rem;
    margin-top: 2.7rem;
  }
  .name {
    color: black !important;
  }
  .phone-between {
    width: 100%;
    border-top: 1px solid #d9d9d9;
    padding: 2rem 1.5rem;
    justify-content: space-between;
  }
  .name-edit {
    color: black;
    cursor: pointer;
  }
  .editableItemsDiv {
    width: 100%;
    position: relative;
  }
  .basic-info {
    padding: none;
  }
  .profile-completion {
    display: none;
  }
  .hvr-status-edit {
    visibility: visible;
  }
  .hvr-phone-edit {
    visibility: visible;
  }
  .hvr-location-edit {
    visibility: visible;
  }
  .hvr-linkedin-edit {
    visibility: visible;
  }
  .responsive-pp {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-end;
  }
  .phone-block {
    display: block;
  }
}
.lbl-text {
  font-size: 1.4rem;
  color: #989fa6;
}
.info-text {
  font-size: 1.4rem;
}
.name {
  font-size: 1.6rem !important;
  font-weight: bold;
  color: white;
}
.v-input {
  text-align: right !important;
  font-size: 1.4rem !important;
}
</style>
